import * as React from "react";
import {cx} from "emotion";

import "./other-credits.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

import {groupSections} from "../../common/group-sections";

import {AdBudgetSection}    from "./ad-budget/ad-budget-section";
import {PromoCodesSection}  from "./promo-codes/promo-codes-section";
import {StoreCreditSection} from "./store-credit/store-credit-section";
import {VoucherSection}     from "./voucher/voucher-section";

export const OtherCredits = ({store, next}) => cs(
    ["sections", ({}, next) => cs(
        ["promoCodesSection" , (_, next) => PromoCodesSection({store, next})],
        ["storeCreditSection", (_, next) => StoreCreditSection({store, next})],
        ["voucherSection"    , (_, next) => VoucherSection    ({store, next})],
        ["adBudgetSection"   , (_, next) => AdBudgetSection   ({store, next})],
        ({voucherSection, promoCodesSection, adBudgetSection, storeCreditSection, }) => next([
            promoCodesSection,
            storeCreditSection,
            voucherSection,
            adBudgetSection,
        ]),
    )],
    ({sections}) => next({
        ...groupSections(sections),
        available: !!sections.find((s) => s.available),
        render: ({className}) => (
            <div className={cx("other-credits-2nb", className)}>
                {sections.map((s, i) => cs(
                    keyed(i),
                    () => s.available && s.render(),
                ))}
            </div>
        ),
    }),
);
